(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const root = document.documentElement;
    const announcement = document.querySelector('.announcement-bar-section');
    let lastScrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
    const hideStartOffset = 80;
    const minDelta = 3;

    const updateHeaderHeight = () => {
      const h = Math.round(header.getBoundingClientRect().height);
      if (h > 0) root.style.setProperty('--header-height', `${h}px`);
    };

    const setFloatingTopOffset = () => {
      const scrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      if (scrollTop <= 0 || !header.classList.contains('bs-header-floating')) {
        root.style.setProperty('--bs-header-offset-top', '0px');
        return;
      }
      if (!announcement) {
        root.style.setProperty('--bs-header-offset-top', '0px');
        return;
      }
      const ann = announcement.getBoundingClientRect();
      if (ann.bottom <= 0) {
        root.style.setProperty('--bs-header-offset-top', '0px');
      } else {
        root.style.setProperty('--bs-header-offset-top', `${Math.max(0, ann.bottom)}px`);
      }
    };

    const onScroll = () => {
      const scrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      const delta = scrollTop - lastScrollTop;

      if (scrollTop <= 0) {
        header.classList.remove('bs-header-floating');
        header.classList.remove('bs-header-hidden');
        root.style.setProperty('--bs-header-offset-top', '0px');
        updateHeaderHeight();
        lastScrollTop = scrollTop;
        return;
      }

      if (scrollTop > 0) {
        header.classList.add('bs-header-floating');
      }

      setFloatingTopOffset();
      updateHeaderHeight();

      if (Math.abs(delta) < minDelta) return;

      if (delta > 0 && scrollTop > hideStartOffset) {
        header.classList.add('bs-header-hidden');
      } else if (delta < 0) {
        header.classList.remove('bs-header-hidden');
      }

      lastScrollTop = scrollTop;
    };

    const onResize = () => {
      updateHeaderHeight();
      setFloatingTopOffset();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    updateHeaderHeight();
    setFloatingTopOffset();
  })();

  } catch(e) { console.error(e); }
})();
})();
